import { Component, OnInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
    selector: 'app-units-chart',
    templateUrl: './units-chart.component.html',
    styleUrls: ['./units-chart.component.scss']
})
export class UnitsChartComponent implements OnInit {

    @Input() labelArray: any;
    @Input() valuesArray: any;

    constructor() { }

    ngOnInit() {
    }
    ngAfterViewInit() {
        this.processChartData();
    }

    processChartData() {
        var canvas = <HTMLCanvasElement>document.getElementById("unitsDoughnutChart");

        let backgroundColorArray = ['rgba(54, 162, 235, 0.2)', 'rgba(230, 245, 255, 0.2)'];
        let borderColorArray = ['rgba(54, 162, 235, 1)', 'rgba(230, 245, 255, 1)'];
        var mychart = new Chart(canvas, {
            type: 'doughnut',
            data: {
                labels: this.labelArray,
                datasets: [{
                    data: this.valuesArray,
                    backgroundColor: backgroundColorArray,
                    borderColor: borderColorArray
                }]
            },
            options: {
                responsive: true,
                animation: {
                    animateScale: true,
                    animateRotate: true
                }
            }
        });
    }

}